import { render, staticRenderFns } from "./persona.vue?vue&type=template&id=12bc3cc0&scoped=true"
import script from "./persona.vue?vue&type=script&lang=js"
export * from "./persona.vue?vue&type=script&lang=js"
import style0 from "./persona.vue?vue&type=style&index=0&id=12bc3cc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc3cc0",
  null
  
)

export default component.exports